export const UploadGlossary= Symbol('UploadGlossary');

/**
* 上传术语表
* @description 用于上传术语表
* @param params File
 */
export interface UploadGlossary {
    uploadGlossary(params: File): Promise<void>;
}
